import { useEffect, useState } from "react";
import { DoorOpen, Keyboard } from "lucide-react";

const NEUTRAL_URL = "https://www.google.com/search?q=weather+today";

function quickExit() {
  try {
    // Open a neutral page in a new tab (best effort — may be blocked)
    try {
      window.open(NEUTRAL_URL, "_blank", "noopener,noreferrer");
    } catch {}
    // Replace the current tab so back-button can't recover the site
    window.location.replace(NEUTRAL_URL);
  } catch {
    window.location.href = NEUTRAL_URL;
  }
}

export default function PanicButton() {
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      // Press Escape twice within 500ms to trigger quick exit
      if (e.key === "Escape") {
        if (window.__em_lastEsc && Date.now() - window.__em_lastEsc < 500) {
          quickExit();
        } else {
          window.__em_lastEsc = Date.now();
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-[70] flex flex-col items-end gap-2">
      {showHint && (
        <div
          className="max-w-xs text-xs bg-[#0F172A] border border-white/10 text-slate-200 rounded-xl p-3 shadow-lg"
          role="tooltip"
        >
          <p>
            <strong>Quitter discrètement</strong> ferme ce site et t'envoie sur une page neutre.
            L'onglet est remplacé — le bouton Retour ne ramène pas ici.
          </p>
          <p className="mt-2 text-slate-400 flex items-center gap-1.5">
            <Keyboard className="w-3.5 h-3.5" /> Astuce : appuie 2× sur <kbd className="px-1.5 py-0.5 rounded bg-white/10">Esc</kbd>.
          </p>
        </div>
      )}
      <button
        onClick={quickExit}
        onMouseEnter={() => setShowHint(true)}
        onMouseLeave={() => setShowHint(false)}
        onFocus={() => setShowHint(true)}
        onBlur={() => setShowHint(false)}
        data-testid="panic-button"
        aria-label="Quitter discrètement vers une page neutre"
        className="group inline-flex items-center gap-2 bg-slate-900/90 backdrop-blur border border-white/15 hover:bg-rose-600 hover:border-rose-500 text-white font-semibold px-4 py-2.5 rounded-full shadow-xl shadow-black/30"
      >
        <DoorOpen className="w-4 h-4 group-hover:text-white" />
        <span className="text-sm">Quitter discrètement</span>
      </button>
    </div>
  );
}
